'use client';

import React from 'react';
import { TasticProps } from 'frontastic/tastics/types';
import InstantSearch from 'components/HOC/InstantSearch';
import LocalizedIndex from 'providers/algolia/localized-index';
import ProductSliderAlgoliaYouLike, { ProductSliderYoulikeProps } from 'components/commercetools-ui/organisms/product/product-slider-algolia-you-like';


const ProductListYouSliderTastic = ({ data }: TasticProps<ProductSliderYoulikeProps>) => {
    return (
      <InstantSearch>
        <LocalizedIndex type="products">
          <ProductSliderAlgoliaYouLike  data={data.data.dataSource.items} />
        </LocalizedIndex>
      </InstantSearch>
    );

};

export default ProductListYouSliderTastic;